import { render } from "./Plot_Detail.vue?vue&type=template&id=22f350d9"
import script from "./Plot_Detail.vue?vue&type=script&lang=js"
export * from "./Plot_Detail.vue?vue&type=script&lang=js"

import "./Plot_Detail.vue?vue&type=style&index=0&id=22f350d9&lang=scss"
script.render = render

export default script